import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { LegacyEmailReceiptEntity } from './legacy-email-receipt.entity';

@Index('_messageId__deleted_userId', ['messageId', 'deletedUserId'], {})
@Entity('_email_activity')
export class LegacyEmailActivityEntity extends BaseEntity {
	@Column('int', { name: '_fk__email_receipt__id', unsigned: true })
	public fkEmailReceiptId!: number;

	@Column('varchar', { name: '_action', length: 128 })
	public action!: string;

	@Column('text', { name: '_linkUrl', nullable: true })
	public linkUrl!: string | null;

	@Column('varchar', { name: '_linkGuid', nullable: true, length: 128 })
	public linkGuid!: string | null;

	@Column('datetime', { name: '_activityDate', nullable: true })
	public activityDate!: Date | null;

	@Column('varchar', { name: '_messageId', nullable: true, length: 70 })
	public messageId!: string | null;

	@Column('longtext', { name: '_message', nullable: true })
	public message!: string | null;

	@ManyToOne(
		() => LegacyEmailReceiptEntity,
		(emailReceipt) => emailReceipt.emailActivities,
		{
			onDelete: 'RESTRICT',
			onUpdate: 'RESTRICT',
		},
	)
	@JoinColumn([{ name: '_fk__email_receipt__id', referencedColumnName: 'id' }])
	public fkEmailReceipt!: LegacyEmailReceiptEntity;
}
